/*@flow*/
import type { Node } from 'react';
import { createElement } from 'react';
import * as I from 'immutable';
import type { ComponentPropsT } from '../types';
import getTemplate from '../util/getTemplate';
import { getDefaultLabel } from '../util';
import getTransformer from '../util/getTransformer';
import { useLocals, useField } from '../hooks';

export default function CheckboxComponent(props: ComponentPropsT): Node {
  const { path } = props;
  const { fieldOptions } = useField(path);
  const transName = 'checkbox';
  const transformer = getTransformer(fieldOptions, transName);
  const locals: $Shape<{ label?: string }> = useLocals(path, { transformer });
  let label = locals.label;
  if (!label) {
    // Checkboxes must always have a label.
    label = getDefaultLabel(I.List(path).last());
  }
  const template = getTemplate(fieldOptions, 'checkbox');
  return createElement(template, { ...locals, label });
}
